import React from 'react';

/** A spinner; with `label` it is announced (role="status"), without it is decorative. */
export function Spinner({ size = 20, label, className = '' }) {
  return (
    <span
      className={`ui-spinner ${className}`.trim()}
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
      style={{ width: size, height: size }}
    >
      {label && <span className="visually-hidden">{label}</span>}
    </span>
  );
}

/** A placeholder block while content loads. */
export function Skeleton({ width = '100%', height = 16, radius, className = '', style }) {
  return (
    <span
      className={`ui-skeleton ${className}`.trim()}
      aria-hidden="true"
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

export default Spinner;
